import {TextField, TextFieldProps} from "@mui/material";
import {forwardRef} from "react";

type Props = TextFieldProps;

/**
 * Verificar se vai funcionar pro Select que tem children
 */
const ProcessTextField = forwardRef<HTMLInputElement, Props>((props, ref) => {
  return (
    <TextField
      size="small"
      fullWidth
      {...props}
      value={props.value === null ? "" : props.value}
      inputRef={ref}
    />
  );
});

ProcessTextField.displayName = "ProcessTextField";

export default ProcessTextField;
